// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/wssocial/entity/message/v1/send.proto (package social.wssocial.entity.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Channel } from "./base_pb.js";
import { SendTypingIndicator } from "../../wsevent/chat/v1/typing_indicator_pb.js";

/**
 * @generated from message social.wssocial.entity.message.v1.SendMessage
 */
export const SendMessage = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.SendMessage",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SendMessage_Type) },
    { no: 2, name: "payload", kind: "message", T: Payload },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendMessage.Type
 */
export const SendMessage_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.SendMessage.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_PING", localName: "PING"},
    {no: 2, name: "TYPE_SUBSCRIBE", localName: "SUBSCRIBE"},
    {no: 3, name: "TYPE_UNSUBSCRIBE", localName: "UNSUBSCRIBE"},
    {no: 4, name: "TYPE_BROADCAST", localName: "BROADCAST"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.Payload
 */
export const Payload = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.Payload",
  () => [
    { no: 1, name: "channel", kind: "message", T: Channel, oneof: "payload" },
    { no: 2, name: "event", kind: "message", T: SendEvent, oneof: "payload" },
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent
 */
export const SendEvent = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SendEvent_Type) },
    { no: 2, name: "data", kind: "message", T: SendEvent_Data },
  ],
);

/**
 * @generated from enum social.wssocial.entity.message.v1.SendEvent.Type
 */
export const SendEvent_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.wssocial.entity.message.v1.SendEvent.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CHAT_TYPING_INDICATOR", localName: "CHAT_TYPING_INDICATOR"},
  ],
);

/**
 * @generated from message social.wssocial.entity.message.v1.SendEvent.Data
 */
export const SendEvent_Data = /*@__PURE__*/ proto3.makeMessageType(
  "social.wssocial.entity.message.v1.SendEvent.Data",
  () => [
    { no: 1, name: "chat_typing_indicator", kind: "message", T: SendTypingIndicator, oneof: "data" },
  ],
  {localName: "SendEvent_Data"},
);

